import { useEffect, useState } from 'react';
import client from '../contentfulClientToken'; // Assuming this is correctly set up to point to your Contentful client instance

const fetchTitlesFromContentType = async (contentType) => {
    //console.log(`Fetching titles for contentType: ${contentType}`); // Debugging log
    const response = await client.getEntries({
        content_type: contentType,
        select: 'fields.nomPage' // Selecting only the 'nomPage' field for efficiency
    });
    return response.items.map(item => ({
        nomPage: item.fields.nomPage,
        contentType, // Store contentType for reference
    }));
};

const fetchAllTitles = async () => {
    const contentTypes = ['concept', 'quiSuisJe', 'traiteur', 'catering', 'restoBingo', 'projetsComestibles', 'producteurices', 'infosEtDevis']; // Replace these with your actual content type IDs
    const promises = contentTypes.map(fetchTitlesFromContentType);
    const results = await Promise.all(promises);
    return results.flat(); // Flatten the array of arrays into a single array
};

const MenuTop = () => {
    const [titles, setTitles] = useState([]);
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
        fetchAllTitles().then(setTitles);
    }, []);

    // Intersection Observer for section highlighting
    useEffect(() => {
        const observerOptions = {
            root: null,
            // Create a narrow band centered in the viewport so a section becomes active when its center crosses mid-screen
            rootMargin: '-50% 0px -50% 0px',
            threshold: 0
        };

        const observerCallback = (entries) => {
            // Among intersecting entries, choose the one whose center is closest to viewport center
            const centerY = window.innerHeight / 2;
            let best = { id: null, dist: Infinity };

            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                const rect = entry.target.getBoundingClientRect();
                const elCenter = rect.top + rect.height / 2;
                const dist = Math.abs(elCenter - centerY);
                const sectionId = entry.target.id || entry.target.getAttribute('data-content-type');
                if (sectionId && dist < best.dist) {
                    best = { id: sectionId, dist };
                }
            });

            if (best.id) {
                setActiveSection(best.id);
            }
        };

        // Fallback: Set last section as active when near bottom of page
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // If near the very top of the page, force the first section as active
            if (scrollTop <= 10 && titles.length > 0) {
                const firstSection = titles[0];
                if (firstSection) {
                    setActiveSection(firstSection.contentType);
                }
            }

            // If scrolled to within 100px of bottom, set last section as active
            if (scrollTop + windowHeight >= documentHeight - 100) {
                const lastSection = titles[titles.length - 1];
                if (lastSection) {
                    setActiveSection(lastSection.contentType);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Initialize active section immediately (e.g., select first section at top)
        handleScroll();

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // Wait a bit for DOM to be ready, then observe sections
        const timeoutId = setTimeout(() => {
            const sections = document.querySelectorAll('section[id], section[data-content-type]');
            sections.forEach((section, index) => {
                observer.observe(section);
            });
        }, 500); // Increased timeout

        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
            window.removeEventListener('scroll', handleScroll);
        };
    }, [titles]); // Add titles as dependency

    // Effect to handle background color changes when activeSection changes
    // Commented out to maintain consistent background color
    /*
    useEffect(() => {
        // Reset all sections to original color first
        const allSections = document.querySelectorAll('section[data-content-type], section[id]');
        allSections.forEach(section => {
            const innerContainer = section.querySelector('.inner-container');
            if (innerContainer) {
                innerContainer.style.backgroundColor = '#acb1a3c6';
            }
        });

        // Set active section to new color
        if (activeSection) {
            const activeSectionElement = document.querySelector(`[data-content-type="${activeSection}"], #${activeSection}`);
            if (activeSectionElement) {
                const innerContainer = activeSectionElement.querySelector('.inner-container');
                if (innerContainer) {
                    innerContainer.style.backgroundColor = '#707871e2';
                }
            }
        }
    }, [activeSection]);
    */

    return (
        <div className="menu-top">
            <ul id="menu-top-list">
                {titles.map((title, index) => (
                    <li
                        key={index}
                        className={activeSection === title.contentType ? 'active' : ''}
                    >
                        <a
                            href={`#${title.contentType}`}
                            onClick={(e) => {
                                e.preventDefault();
                                const targetId = `${title.contentType}`;
                                const target = document.getElementById(targetId) || document.querySelector(`[data-content-type="${title.contentType}"]`);
                                if (!target) return;

                                const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
                                const lenis = typeof window !== 'undefined' ? window.__lenis : null;
                                if (!isMobile && lenis && typeof lenis.scrollTo === 'function') {
                                    // Desktop/tablet: use Lenis
                                    lenis.scrollTo(target, { offset: -10, duration: 0.7 });
                                } else {
                                    // Mobile or no Lenis: use native smooth scroll
                                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }

                            }}
                        >
                            {title.nomPage}
                        </a>
                    </li>

                ))}
                {/*   <li>
                    <a
                        href="https://www.instagram.com/labo_lol/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                            }
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                        </svg>
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.facebook.com/p/Labo-Lol-61555639623075/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                            }
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-label="Facebook">
                            <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.326v21.348C0 23.403.597 24 1.326 24h11.495v-9.294H9.691v-3.622h3.13V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.466.099 2.797.143v3.24l-1.919.001c-1.504 0-1.795.715-1.795 1.763v2.314h3.587l-.467 3.622h-3.12V24h6.116C23.403 24 24 23.403 24 22.674V1.326C24 .597 23.403 0 22.675 0z" />
                        </svg>
                    </a>
                </li> */}
            </ul>
        </div>
    );
};

export default MenuTop;